import wireframeBarChartMenuIcon from '../assets/icons/wireframeBarChartMenuIcon.svg';
import WireframeImage from './WireframeImage';

class WireframeBarChart extends WireframeImage {
  constructor(fabricObject) {
    fabricObject.style ||= 'barChart';
    super(fabricObject);
  }

  static iconSvg() {
    return wireframeBarChartMenuIcon;
  }

  static externalName(): string {
    return 'Bar chart';
  }
}

export default WireframeBarChart;
